import { Box, HStack, Link, Text } from "@chakra-ui/react";
import React, { ReactElement } from "react";
import REIVHeader from "./reivHeader";

type props = {
  SideBarHeading: ReactElement;
  SideBarContent: ReactElement;
  SideBarDisclaimer: ReactElement;
  PageHeader?: ReactElement;
};

export const PageWithSideBar: React.FC<props> = ({
  children,
  SideBarHeading,
  SideBarContent,
  SideBarDisclaimer,
  PageHeader,
}) => {
  return (
    <Box p={0} display={{ md: "flex" }} height="100%" minH="100vh">
      <Box
        flexShrink={0}
        backgroundColor="white"
        boxShadow={{
          md: "0 2px 2px 0 rgb(0 0 0 / 14%), 0 3px 1px -2px rgb(0 0 0 / 20%)",
        }}
      >
        <HStack
          justify="space-between"
          display="flex"
          flexDirection="column"
          maxW="400px"
          padding="30px"
          margin="auto"
          height={["100%", "100vh"]}
        >
          <REIVHeader />
          {SideBarHeading}
          {SideBarContent}
          {SideBarDisclaimer}
          <Text
            alignSelf="flex-start"
            fontSize="sm"
            padding="0 4px 0 4px"
            mt={"10px!important"}
          >
            Need help? Contact us:{" "}
            <Link href="mailto:membership@reiv.com.au" isExternal>
              membership@reiv.com.au
            </Link>
          </Text>
        </HStack>
      </Box>
      <Box
        flexGrow={1}
        alignItems="center"
        margin="auto"
        display="flex"
        flexDirection="column"
      >
        {PageHeader && (
          <Box
            margin={"auto"}
            mb={{ base: 4, md: 6 }}
            mt={{ base: 4, md: 6 }}
            mr={{ base: 4, md: 6 }}
            ml={{ base: 4, md: 6 }}
            maxW="650px"
          >
            {PageHeader}
          </Box>
        )}
        <Box
          margin={"auto"}
          mb={{ base: 4, md: 6 }}
          mr={{ base: 4, md: 6 }}
          ml={{ base: 4, md: 6 }}
          maxW="650px"
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};
